"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrappStyled = exports.BoxStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _helpers = require("./helpers");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n\n      p,\n      ul,\n      ol,\n      pre,\n      blockquote,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5,\n      h6 {\n        color: ", ";\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n          padding-bottom: 60px;\n          padding-top: 60px;\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding-left: 93px;\n  padding-right: 93px;\n\n  ", " {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n\n  ", " {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n\n  ", "\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding: 60px 30px;\n    padding-bottom: ", ";\n    padding-top: ", ";\n\n    ", " {\n      padding-bottom: ", ";\n      padding-top: ", ";\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  ", " {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n  ", " {\n    padding-left: 9px;\n    padding-right: 9px;\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BoxStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject(), function (_ref) {
  var _ref$theme = _ref.theme,
      removeTopPadding = _ref$theme.removeTopPadding,
      removeBottomPadding = _ref$theme.removeBottomPadding;
  return (0, _uiKit.css)(_templateObject2(), removeBottomPadding ? 0 : '60px', removeTopPadding ? 0 : '60px', _uiKit.GridBreakpointsMediaDown.sm, removeBottomPadding ? 0 : '30px', removeTopPadding ? 0 : '30px');
}, _uiKit.GridBreakpointsMediaDown.lg, _uiKit.GridBreakpointsMediaDown.md, function (_ref2) {
  var $theme = _ref2.theme.$theme;
  return $theme && (0, _helpers.getTheme)($theme);
}, (0, _helpers.getDefaultStyles)());
exports.BoxStyled = BoxStyled;
var WrappStyled = (0, _uiKit.styled)("div")(_templateObject3(), _uiKit.GridBreakpointsMediaDown.lg, _uiKit.GridBreakpointsMediaDown.md, function (_ref3) {
  var isBlock = _ref3.theme.isBlock;
  return isBlock ? (0, _uiKit.css)(_templateObject4(), _uiKit.Colors.white) : "";
}, function (_ref4) {
  var isDarkTheme = _ref4.theme.isDarkTheme;
  return isDarkTheme && (0, _uiKit.css)(_templateObject5(), _uiKit.Colors.white, _uiKit.Colors.white);
});
exports.WrappStyled = WrappStyled;